<template>
    <ul class="list" v-if="comments[group]">
        <li class="comment" v-for="comment in comments[group]" :key="comment.id" :class="{'tag-me' : comment.id == tag }">
            <div class="image">
                <img class="avatar" :src="comment.owner.avatar" :alt="comment.owner.name">
            </div>
            <div class="comment-content">
                <div class="header">
                    <div class="username" v-text="comment.owner.name"></div>
                    <div class="date" v-text="dateCalendar(comment.created_at)"></div>
                </div>
                <div class="body">
                    <div v-text="comment.body"></div>
                </div>
                <div class="reply">
                    <button class="btn-reply" @click="(showForm = (showForm != comment.id) ? comment.id : null)" v-text="((showForm == comment.id) ? 'Cancel' : 'Reply')"></button>
                    <video-comment-form v-if="showForm == comment.id" :parent-id="comment.id" :video="video" :serie="serie"></video-comment-form>
                    <video-comments-list :comments="comments" :group="comment.id" :video="video" :serie="serie"></video-comments-list>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
    export default {

        props:{
            comments:{
                type: Array,
                required: true,
            },
            group:{
                required: true,
            },
            video: {
                type: Object,
                required: true,
            },
            serie: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                showForm: false,
                tag: '',
            }
        },

        created(){
            this.tag = (new URLSearchParams(window.location.search)).get('tag')
        },
    }
</script>
